import React from 'react';
import {useIntl} from 'react-intl';

import {EActionType, IAfterActionProps, runAfterAction} from 'coreHooks';

import cartMessages from 'brandComponents/product/AddToCartButton/messages';
import AddToCartSuccessMsg from 'brandComponents/product/AddToCartSuccessMsg';
import wishlistMessages from 'brandComponents/product/AddToWishlistButton/messages';
import AddToWishlistSuccessMsg from 'brandComponents/product/AddToWishlistSuccessMsg';

const useAfterAction = () => {
	const intl = useIntl();
	const object: IAfterActionProps = {
		notifyContent: null,
		callback: null,
	};

	const afterAction = (actionType: EActionType) => {
		switch (actionType) {
			case EActionType.WISHLIST_ADDED:
				object.notifyContent = {
					content: <AddToWishlistSuccessMsg isRemoved={false} />,
					type: 'success',
				};

				break;
			case EActionType.WISHLIST_REMOVED:
				object.notifyContent = {
					content: <AddToWishlistSuccessMsg isRemoved={true} />,
					type: 'success',
				};

				break;
			case EActionType.MOVED_TO_WISHLIST:
				object.notifyContent = {
					content: <AddToWishlistSuccessMsg moved={true} />,
					type: 'success',
				};

				break;
			case EActionType.WISHLIST_ERROR:
				object.notifyContent = {
					content: intl.formatMessage(wishlistMessages.errorMsg),
					type: 'error',
				};

				break;
			case EActionType.CART_ADDED:
				object.notifyContent = {
					content: <AddToCartSuccessMsg />,
					type: 'success',
				};

				break;
			case EActionType.CART_ERROR:
				object.notifyContent = {
					content: intl.formatMessage(cartMessages.quantityError),
					type: 'error',
				};

				break;
			default:
				break;
		}

		if (object.notifyContent || object.callback) {
			runAfterAction(object);
		} else {
			throw new Error('No content and no callback for this action');
		}
	};

	return afterAction;
};

export default useAfterAction;
